import React, { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axiosInstance from '../api/axiosInstance';

const defaultFlags = {
  shopEnabled: true,
  checkoutEnabled: true,
  loyaltyEnabled: true,
  recipesEnabled: true,
  chatEnabled: true,
  referralEnabled: true,
  reviewsEnabled: true,
  prizesEnabled: true,
  pointsPurchaseEnabled: true,
  registrationEnabled: true,
  statusBannerEnabled: false,
  statusBannerMessage: '',
  statusBannerType: 'INFO',
  maintenanceMode: false,
};

const SystemContext = createContext(defaultFlags);

export const SystemProvider = ({ children }) => {
  const [flags, setFlags] = useState(defaultFlags);
  const location = useLocation();

  const fetchFlags = () => {
    axiosInstance.get('/system/status')
      .then(res => { if (res.data.success) setFlags({ ...defaultFlags, ...res.data.data }); })
      .catch(() => {});
  };

  // Fetch on every route change
  useEffect(() => {
    fetchFlags();
  }, [location.pathname]);

  // Also poll every 30 seconds in background
  useEffect(() => {
    fetchFlags();
    const interval = setInterval(fetchFlags, 30000);
    return () => clearInterval(interval);
  }, []);

  return (
    <SystemContext.Provider value={flags}>
      {children}
    </SystemContext.Provider>
  );
};

export const useSystem = () => useContext(SystemContext);

export default SystemContext;